import _ from "lodash";
import { HttpServiceError } from "./httpService.interface";

export const isSessionExpired = (error: HttpServiceError): boolean =>
  _.has(error, "response.status") && [401, 403].includes(error.response.status);
